class LineRequestorHelperService {
    buildChartRequest (settings) {
        let chartRequest = { Series: [], Legends: [] };
        chartRequest.YAxisTitle = settings.yAxis.label;
        chartRequest.XAxisTitle = settings.xAxis.label;
        chartRequest.YAxisStartRange = settings.yAxis.minValue;
        chartRequest.YAxisNumberFormat = '0';
        return chartRequest;
    }

    buildSeries (index, name, colour, data) {
        return {
            Index: index,
            Name: name,
            Colour: colour,
            SeriesShape: 'Circle',
            SeriesData: data,
            SmoothedLine: true
        };
    }

    buildLegend (index, name, colour) {
        return {
            Id: index,
            Name: name,
            Colour: colour
        };
    }

    addSeriesAndLegend (chartRequest, seriesIndex, seriesName, seriesColour, data) {
        let series = this.buildSeries(seriesIndex, seriesName, seriesColour, data);
        let legendItem = this.buildLegend(seriesIndex, seriesName, seriesColour);
        chartRequest.Series.push(series);
        chartRequest.Legends.push(legendItem);
    }
}

export const lineRequestorHelperService = new LineRequestorHelperService();
